import { jsx as _jsx } from "react/jsx-runtime";
import { Button, useTheme } from '@mui/material';
export const CtaButton = ({ children, href, size = 'medium', variant = 'primary', startIcon, sx, ...rest }) => {
    const theme = useTheme();
    // Size configurations
    const sizeStyles = {
        small: {
            fontSize: { xs: '13px', md: '14px' },
            px: { xs: 4, md: 6 },
            py: { xs: 1.5, md: 2 },
            minWidth: 'auto',
        },
        medium: {
            fontSize: '16px',
            px: 8,
            py: 3,
            minWidth: 'auto',
        },
        large: {
            fontSize: '18px',
            px: 6,
            py: 3,
            minWidth: '220px',
        },
    };
    // Variant configurations
    const variantStyles = {
        primary: {
            variant: 'contained',
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            border: '1px solid transparent',
            boxShadow: `0 4px 14px ${theme.palette.primary.main}4D`, // 30% opacity
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
                boxShadow: `0 6px 20px ${theme.palette.primary.main}66`, // 40% opacity
            },
        },
        secondary: {
            variant: 'contained',
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText,
            border: '1px',
            borderColor: theme.palette.secondary.dark,
            boxShadow: `0 4px 14px ${theme.palette.secondary.main}4D`, // 30% opacity
            '&:hover': {
                backgroundColor: theme.palette.secondary.dark,
                boxShadow: `0 6px 20px ${theme.palette.secondary.main}66`, // 40% opacity
            },
        },
        outlined: {
            variant: 'outlined',
            borderColor: theme.palette.text.primary,
            color: theme.palette.text.primary,
            backgroundColor: 'transparent',
            '&:hover': {
                borderColor: theme.palette.primary.main,
                backgroundColor: theme.palette.primary.light,
            },
        },
    };
    const currentSize = sizeStyles[size];
    const currentVariant = variantStyles[variant];
    return (_jsx(Button, { href: href, variant: currentVariant.variant, startIcon: startIcon, sx: {
            borderRadius: '6px',
            fontWeight: 600,
            textTransform: 'none',
            ...currentSize,
            ...currentVariant,
            ...sx,
        }, ...rest, children: children }));
};
